import TicketDetailContainer from './TicketDetailContainer';
import TicketCommentContainer from './TicketCommentContainer';
import TicketFileContainer from './TicketFileContainer';
import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { configs } from '@constants/configs/configs';
import { getTicketDetail } from '@actions/individualPortal/ticket/ticketActionCreators';


const TicketSummaryContainer = ({ getTicketDetail }) => {
    const pathname = window.location.pathname;
    const splitUpPath = pathname.split('/');
    const ticketNumber = splitUpPath.pop();

    const [ticketData, setTicketData] = useState();
    const [isSearching, setIsSearching] = useState(true);

    useEffect(() => {
        getTicketDetail(configs.endpoints.TICKET_DETAIL.processReplacements({ id: ticketNumber })).then(response => {
            if (response) {
                setTicketData(response);
            }
            setIsSearching(false);
        }); }, []);

    if (ticketData && !isSearching) {
        return(
            <Fragment>
                <TicketDetailContainer ticket={ticketData} />
                <TicketFileContainer ticket ={ticketData} encTicketId={ticketNumber} />
                <TicketCommentContainer  tData={ticketData} encTicketId={ticketNumber} />
            </Fragment>);
    } else if(!isSearching) {
        return ( <h1><FormattedMessage id='ticket.not_located'/></h1> );
    } else {
        return null;
    }

};
const mapStateToProps = state => ({
    userRole: state.common.environment.user.role,
});

export default connect( mapStateToProps, { getTicketDetail })(TicketSummaryContainer);
